export var LinkStyles = function (props) {
    var isDisabled = props.isDisabled;
    return {
        root: [
            !isDisabled && {
                selectors: {
                    '&:active, &:hover, &:active:hover': {
                        textDecoration: 'underline',
                    },
                },
            },
        ],
    };
};
//# sourceMappingURL=Link.styles.js.map